module.exports = __webpack_public_path__ + "img/equipment-active-table-icon.673337ae.svg";